export const getFieldsSearchResultStyle = (theme) => ({
    display: 'grid',
    gap: '.75rem 1.5rem',
    margin: '.75rem',
    gridTemplateColumns: theme.isTablet() ? 'repeat(auto-fill, 14rem)' : 'repeat(auto-fill, 100%)',
    width: '100%',
    justifyContent: 'center',
    flexDirection: theme.isTablet() ? 'row' : 'column',
});
